import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  alertContainer: {
    marginBottom: theme.spacing(2),
  },
}))

export default useStyles
